export default "__VITE_ASSET__CW9l0tUJ__"